//const API_URL = 'http://192.168.101.200:8000'; // Localserver
const API_URL = 'https://skillspark.your-product.in'; //Production
const SCHOOL_NAME = 'New English School Upalavi';
export default API_URL;